import { IPROP_MAP, modifyProps } from '../../generators/modifyProps';

import { JDSDividerProps } from './generated';

const legacyPadding = ['xx-small', 'x-small', 'x-large', 'xx-large'] as const;

export interface DividerProps extends Omit<JDSDividerProps, 'pad'> {
  pad?: (typeof legacyPadding)[number] | JDSDividerProps['pad'];
  /**
   * @deprecated use `orientation`
   */
  appearance?: JDSDividerProps['orientation'];
}

export const PROP_MAP: IPROP_MAP<DividerProps> = (props) => {
  if (legacyPadding.includes(props.pad as (typeof legacyPadding)[number])) {
    console.warn(
      'sizes starting with xx- are deprecated. Use sizes starting with `xtra`. Ex: x-small => xtra-small'
    );
  }
  return {
    pad: {
      variations: {
        base: {
          pad: 'base'
        },
        huge: {
          pad: 'huge'
        },
        medium: {
          pad: 'medium'
        },
        small: {
          pad: 'small'
        },
        large: {
          pad: 'large'
        },
        'x-small': {
          pad: 'xtra-small'
        },
        'xx-small': {
          pad: 'xtra-xtra-small'
        },
        'x-large': {
          pad: 'xtra-large'
        },
        'xx-large': {
          pad: 'xtra-xtra-large'
        },
        massive: {
          pad: 'massive'
        }
      }
    },
    appearance: {
      properties: {
        orientation: props.appearance || props.orientation
      }
    }
  };
};

export const withLogic =
  (Component: React.ComponentType<DividerProps>): React.FC<DividerProps> =>
  (userProps: DividerProps) => {
    const props = modifyProps(userProps, PROP_MAP);
    return (
      <Component
        {...{
          ...props,
          _withLabel: Boolean(props.label?.length),
          orientation: props.orientation || props.appearance
        }}
      />
    );
  };
